import { TranslatedText } from '@sms/plasma-ui';
import React, { FC } from 'react';

import { IProps } from '../index';

export const PoresClassRow: FC<IProps> = ({ statistics }) => {
  return (
    <>
      {statistics && 'poresClass' in statistics && (
        <li className="seg__statistics__item">
          <p>
            <TranslatedText textKey="Pores Class" />:
          </p>
          <p>{statistics.poresClass}</p>
        </li>
      )}
    </>
  );
};
